"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const defaults_1 = require("data/preferences/defaults");
const utils_1 = require("utils/utils");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.calendarPrefsStyles);
const isIe = require('is-iexplorer') || (0, utils_1.isOldEdge)(); // eslint-disable-line
const CAL_PREFS_DATA = [
    {
        label: 'Show recorded transactions in calendar',
        field: 'showTransactions',
        id: 'cal-pref-show-txns',
    },
    {
        label: 'Show bill and income reminders in calendar',
        field: 'showScheduleTransactions',
        id: 'cal-pref-show-schedule-txns',
    },
];
const PrefsModal = ({ onClose }) => {
    const { classes } = useStyles();
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const onHandleCheck = (0, react_1.useCallback)((field) => (event, checked) => {
        if (event && event.target) {
            setDatasetPreference({ calendarTransaction: {
                    dashboard: { [field]: checked },
                } });
        }
    }, [setDatasetPreference]);
    const onResetDefaults = (0, react_1.useCallback)(() => {
        setDatasetPreference({
            calendarTransaction: Object.assign(Object.assign({}, datasetPreferences.calendarTransaction), { dashboard: Object.assign({}, defaults_1.defaultDatasetPreferences.calendarTransaction.dashboard) }),
        });
    }, [datasetPreferences, setDatasetPreference]);
    const onCLose = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    const onHandleModalClick = (0, react_1.useCallback)((event) => event.stopPropagation(), []);
    const cachedPrefs = (0, react_1.useMemo)(() => { var _a; return (_a = datasetPreferences.calendarTransaction) === null || _a === void 0 ? void 0 : _a.dashboard; }, [datasetPreferences]);
    const calPrefsData = (0, react_1.useMemo)(() => (isEntitySharedUser
        ? CAL_PREFS_DATA.filter((pref) => pref.field !== 'showScheduleTransactions')
        : CAL_PREFS_DATA), [isEntitySharedUser]);
    const renderFields = (0, react_1.useMemo)(() => (calPrefsData.map((pref) => {
        const fieldValue = cachedPrefs[pref.field];
        return (<div className={classes.fieldRoot} key={`CalPrefsItem-${pref.field}`}>
          <div className={classes.fieldLabel}>
            {pref.label}
          </div>
          <Switch_1.default color="primary" checked={fieldValue} value={fieldValue ? 'on' : 'off'} onChange={onHandleCheck(pref.field)} id={pref.id}/>
        </div>);
    })), [onHandleCheck, cachedPrefs, classes, calPrefsData]);
    const renderButton = (onClickHandler, label, id) => (<Button_1.default color="primary" onClick={onClickHandler} id={id}>
      {label}
    </Button_1.default>);
    return (<StdDialog_1.default open classes={isIe ? { paper: classes.dialogPaper } : {}} onClose={onCLose} title="Dashboard Calendar Preferences" onClick={onHandleModalClick}>
      <DialogContent_1.default>
        {cachedPrefs && renderFields}
        <Divider_1.default />
      </DialogContent_1.default>
      <div className={classes.buttonArea}>
        {renderButton(onResetDefaults, 'Reset To Defaults', 'reset-to-defaults')}
        {renderButton(onCLose, 'Done', 'txn-pref-done')}
      </div>
    </StdDialog_1.default>);
};
exports.default = (0, react_1.memo)(PrefsModal);
